import { formatCurrency } from '@shared/formatCurrency';

interface QuotePriceDisplayProps {
  price: number;
  fundingOption?: string;
  label?: string;
  className?: string;
}

export function QuotePriceDisplay({
  price,
  fundingOption,
  label = 'Cost',
  className = '',
}: QuotePriceDisplayProps) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="text-muted-foreground text-xs font-medium">{label}</div>
      <div
        data-testid="quote-card-cost-display"
        className="text-primary-dark flex items-center gap-1 text-sm font-semibold sm:text-base"
      >
        {formatCurrency(price)}
      </div>
      {fundingOption && <div className="text-muted-foreground text-xs italic">{fundingOption}</div>}
    </div>
  );
}
